/* eslint-disable react/button-has-type */
import React, { useRef, useEffect } from 'react';
import './LotDetails.css';
import { useSelector } from 'react-redux';
import LotDetails from './LotDetails';

const LotDetailsContainer = ({ filterSelected = 'all', openEditShippingModal, onConfirm }) => {
  const pollRef = useRef(null);
  useEffect(() => () => {
    if (pollRef.current) {
      Object.values(pollRef.current).forEach((interval) => clearInterval(interval));
    }
  }, []);

  const { lotsWithShippingData } = useSelector((state) => state.shippingReview);
  return lotsWithShippingData && lotsWithShippingData.map((lot) => {
    let isVisible = false;
    if ((filterSelected === 'readyToConfirm' && lot.shippingReviewData.status === 'awaiting_approval')
      || (filterSelected === 'needsReview' && lot.shippingReviewData.status === 'failed')
      || (filterSelected === 'all')) {
      isVisible = true;
    }
    return (
      <div key={lot.lotID} className={`lot-details-container ${isVisible ? '' : 'd-none'}`}>
        <LotDetails lotInfo={lot} openEditShippingModal={openEditShippingModal} onConfirm={onConfirm} ref={pollRef} />
      </div>
    );
  });
};

export default LotDetailsContainer;
